<template>
    <div class="close-button" :style="{ color }">
        <span class="icon-clear"></span>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "CloseButton",
    props: {
        color: {
            type: String,
            default: "var(--white)"
        }
    }
});
</script>

<style scoped>
.close-button {
    font-size: 2em;
    font-weight: bold;
    text-decoration: none;
    /* color: var(--white); */
}
</style>
